import { datadogRum } from '@datadog/browser-rum';
import { useMutation } from '@tanstack/react-query';

import {
  invalidateAllPlanQueries,
  invalidateCertificateQueries,
} from '@/utils/queryInvalidation';

import { patchAutoAssignMutation } from '@/_generated/api-clients/xp';

export const usePatchAutoAssign = () =>
  useMutation({
    ...patchAutoAssignMutation(),
    onSuccess: async (_data, variables) => {
      await Promise.all([
        invalidateAllPlanQueries(variables.path.planId),
        invalidateCertificateQueries(variables.path.planId),
      ]);
    },
    onError: error => {
      datadogRum.addError(error, { section: 'autoAssign' });
    },
  });
